import React from "react";
import {
  LayoutDashboard,
  Send,
  RefreshCcw,
  Landmark,
  CreditCard,
  BarChart3,
  UserPlus,
  Edit,
} from "lucide-react";
import { NavLink } from "react-router-dom";

const menuItems = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, link: "/dashboard" },
  { id: "CreateAccount", label: "Create Account", icon: UserPlus, link: "/account" },
  { id: "send", label: "Send Money", icon: Send, link: "/send-money" },
  { id: "exchange", label: "Exchange", icon: RefreshCcw, link: "/exchange-money" },
  { id: "wire", label: "Wire Transfer", icon: Landmark, link: "/wire-transfer" },
  { id: "request", label: "Payment Request", icon: CreditCard, link: "/request" },
  { id: "edit", label: "Edit Transaction", icon: Edit, link: "/edit-transaction" },
  { id: "transactionRequest", label: "Transaction Request", icon: CreditCard, link: "/transaction-request" },
  { id: "reports", label: "Reports", icon: BarChart3, link: "/reports" },
];

const Sidebar = () => {
  return (
    <aside className="h-[calc(100vh-64px)] w-72 text-slate-800 bg-white shadow-sm border-r border-slate-200 flex flex-col">
      
      {/* Brand */}
      {/* <div className="px-6 py-5 border-b border-slate-700">
        <h1 className="text-xl font-semibold tracking-wide">
          Admin<span className="text-red-500 ml-1">Secure</span>
        </h1>
        <p className="text-xs text-slate-400 mt-1">
          Corporate Banking
        </p>
      </div> */}

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.id}
              to={item.link}
              className={({ isActive }) =>
                `
                w-full flex items-center gap-3 px-4 py-3 rounded-xl
                transition-all duration-200
                ${
                  isActive
                    ? "bg-slate-700 text-white shadow-lg shadow-red-500/10"
                    : "text-slate-800 hover:bg-slate-700 hover:text-white"
                }
              `
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    size={18}
                    className={isActive ? "text-red-400" : "text-slate-800"}
                  />
                  <span className="text-sm font-medium">
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-6 py-4 border-t border-slate-700 text-xs text-slate-400">
        © 2026 HSBC Secure
      </div>
    </aside>
  );
};

export default Sidebar;
